export default {
  MAX_NAME_LENGTH: 512,
  MAX_TICKET_TYPES: 25,
  MAX_TICKET_QUANTITY_PER_TICKET_TYPE: 10000,
  MAX_TICKET_QUANTITY_PER_USER: 100,
  MAX_TICKET_PRICE: 1000000,
  WRITE_BATCH_SIZE: 25,
};
